<template>
  <div>
    <!-- search -->
    <div class="table-page-search-wrapper">
      <a-form>
        <a-row :gutter="48">
          <a-col :md="20" style="display:flex">
            <a-form-item label="名称">
              <a-input placeholder="请输入菜品名称" v-model="search.name" />
            </a-form-item>

            <a-button
              class="sm"
              type="primary"
              style="margin-left:20px;margin-top: 4px;"
              @click="searchList"
            >
              <a-icon type="search" />查询</a-button
            >
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 列表 -->
    <a-list
      class="menuListContent"
      :grid="{ gutter: 16, column: 6 }"
      :dataSource="menuList"
      :pagination="pagination"
      :loading="listLoading"
    >
      <a-list-item slot="renderItem" slot-scope="item">
        <a-card hoverable style="width:100%;">
          <div class="itemImgContent">
            <img
              :alt="item.name"
              :title="item.name"
              style="width:100%;"
              :src="item.imgUrl ? item.imgUrl : 'images/noImg.jpg'"
              onerror="this.src='images/noImg.jpg'"
              slot="cover"
            />
          </div>
          <template class="ant-card-actions" slot="actions">
            <a-icon type="eye" title="详情" @click="detailItem(item)" />
            <a-icon
              type="plus"
              title="导入到我的菜品库"
              @click="addToOwn(item)"
            />
          </template>
          <a-card-meta>
            <a slot="title">{{ item.name }}</a>
          </a-card-meta>
        </a-card>
      </a-list-item>
    </a-list>

    <!-- 详情弹窗 -->
    <menu-detail
      :showModal="detailModalShow"
      :detailData="detailDataList"
      @cancel="detailModalHide"
    ></menu-detail>
  </div>
</template>

<script>
import { getPublicMenuList, importMenuToOwn, getPublicMenuDetail } from '@/apis/menu'
import menuDetail from '../tpl/menu-detail'

export default {
  data() {
    return {
      menuList: [],
      search: {
        name: ''
      },
      listLoading: false,
      pagination: {
        onChange: (page, pageSize) => {
          this.pagination.current = page
          this.pagination.pageSize = pageSize
          this._getPublicMenuList()
        },
        total: 0,
        pageSize: 12,
        current: 1,
        showTotal: total => `共 ${total} 条`,
        pageSizeOptions: ['12', '24', '36', '48'],
        defaultPageSize: 12,
        showQuickJumper: true,
        showSizeChanger: true,
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this._getPublicMenuList()
        }
      },
      // 详情模态框
      detailModalShow: false,
      detailDataList: []
    }
  },
  props: {
    tabIndex: String
  },
  methods: {
    searchList() {
      this._getPublicMenuList()
    },
    // 获取菜品列表
    _getPublicMenuList() {
      this.listLoading = true
      getPublicMenuList({
        pageIndex: this.pagination.current,
        pageSize: this.pagination.pageSize,
        name: this.search.name
      }).then((res) => {
        this.listLoading = false
        if (res.data.state === 1) {
          if (res.data.attribute.rows.length) {
            this.menuList = res.data.attribute.rows
            this.pagination.total = res.data.attribute.count
          }
        }
      }, res => {
        this.listLoading = false
      });
    },

    // 导入我的营养套餐
    addToOwn(item) {
      const that = this
      that.$confirm({
        title: '您确定要将该菜品导入到您的菜品库吗?',
        onOk() {
          importMenuToOwn({
            list: JSON.stringify([item.id])
          }).then(res => {
            if (res.data.state === 1) {
              that.$message.success('导入成功！');
            }
          })
        }
      })
    },
    // 模态框
    detailModalHide() {
      this.detailModalShow = false
    },
    detailItem(item) {
      this.detailModalShow = true
      getPublicMenuDetail({
        id: item.id
      }).then(res => {
        if (res.data.state === 1) {
          this.detailDataList = res.data.attribute.map((item, index) => ({
            index: index + 1,
            key: item.componentId,
            name: item.foodName,
            code: item.foodCode,
            weight: item.weight === 0 ? '-' : `${item.weight}g`
          }))
        }
      })
    }
  },
  created() {
    // 获取列表
    this._getPublicMenuList();
  },
  components: {
    menuDetail
  },
  watch: {
    tabIndex: function (data) {
      if (data === '2') {
        this._getPublicMenuList()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.table-page-search-wrapper {
  .ant-form-item {
    display: flex;
  }
}
.ant-form-item-control-wrapper {
  width: 100% !important;
}
.itemImgContent {
  position: relative;
  width: 100%;
  height: 0;
  padding-top: 100%;

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.menuListContent /deep/.ant-card-hoverable:hover {
  -webkit-box-shadow: 0 4px 10px rgba(0, 0, 0, 0.09);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.09);
  border-color: rgba(0, 0, 0, 0.09);
}
.menuListContent /deep/ .ant-card-body {
  padding: 0;
}
.menuListContent .ant-card-meta {
  text-align: center;
  line-height: 40px;
}
.menuListContent .ant-card-meta /deep/.ant-card-meta-title {
  font-size: 14px;
}
</style>
